import commonMutations from 'top20common/distribution/store/mutations';

export default {
  ...commonMutations,
  mutateCvPreviewPdfLoadingState(state, loading) {
    state.cvPreviewPdfLoadingState = loading;
  }
};
